import { PLATFORM_LOGOS, type PlatformIconKey } from "@/lib/integrations/platform-logos";

/** Inherit feature-icon colors, or retain tonal detail for overlapping brand shapes. */
export function PlatformIcon({ icon, size = 16, className }: {
  icon: PlatformIconKey;
  size?: number;
  className?: string;
}) {
  const logo = PLATFORM_LOGOS[icon];
  const mask = `url("/integration-logos/${logo.file}") center / contain no-repeat`;
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        display: "inline-block", width: size, height: size, flexShrink: 0,
        verticalAlign: "middle", backgroundColor: "currentColor",
        mask, WebkitMask: mask,
        // Keep masked marks visible in printed dashboard/report cards.
        printColorAdjust: "exact", WebkitPrintColorAdjust: "exact",
      }}
    />
  );
}
